/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cv_Extract_Form_Enum_Icsrm_Andere11Inputs */

const en_cv_extract_form_enum_icsrm_andere11 = /** @type {(inputs: Cv_Extract_Form_Enum_Icsrm_Andere11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other University`)
};

const de_cv_extract_form_enum_icsrm_andere11 = /** @type {(inputs: Cv_Extract_Form_Enum_Icsrm_Andere11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Andere Hochschule`)
};

/**
* | output |
* | --- |
* | "Other University" |
*
* @param {Cv_Extract_Form_Enum_Icsrm_Andere11Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cv_extract_form_enum_icsrm_andere11 = /** @type {((inputs?: Cv_Extract_Form_Enum_Icsrm_Andere11Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Extract_Form_Enum_Icsrm_Andere11Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_extract_form_enum_icsrm_andere11(inputs)
	return en_cv_extract_form_enum_icsrm_andere11(inputs)
});
export { cv_extract_form_enum_icsrm_andere11 as "cv_extract_form_enum_ICSRM_ANDERE" }